'use client';

import { OPEN_COOKIE_SETTINGS_EVENT } from '@lib/analytics/constants';
import { useCallback, useEffect, useState } from 'react';

export const useCookieSettingsModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handler = () => setIsOpen(true);
    window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, handler);
    return () =>
      window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, handler);
  }, []);

  return {
    isOpen,
    open: useCallback(() => setIsOpen(true), []),
    close: useCallback(() => setIsOpen(false), []),
  };
};
